import { type FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import InfoIcon from 'assets/svg/app/info-white.svg'
import { Body } from 'components/Text'
import { FlexDivCol } from 'components/layout/flex'
import { GridDivCentered } from 'components/layout/grid'

interface InfoRowProps {
	leftText: string
	rightText: string
}

const InfoRow: FC<InfoRowProps> = memo(({ leftText, rightText }) => (
	<GridContainer>
		<Body color="secondary">{leftText}</Body>
		<InfoIcon width={12} height={12} />
		<Body color="secondary">{rightText}</Body>
	</GridContainer>
))

const DepositInfo = memo(() => {
	const { t } = useTranslation()

	const infoRows = [
		{
			key: 'auto-channeled',
			leftText: t('account.deposit-section.deposit-auto-channeled-to'),
			rightText: t('account.deposit-section.unified-kwenta-account'),
		},
		{
			key: 'deposit-arrival',
			leftText: t('account.deposit-section.deposit-arrival'),
			rightText: t('account.deposit-section.one-confirmation'),
		},
		{
			key: 'withdrawal-unlocked',
			leftText: t('account.deposit-section.withdrawal-unlocked'),
			rightText: t('account.deposit-section.one-confirmation'),
		},
	]

	return (
		<FlexDivCol rowGap="4px">
			{infoRows.map((row) => (
				<InfoRow key={row.key} leftText={row.leftText} rightText={row.rightText} />
			))}
		</FlexDivCol>
	)
})

const GridContainer = styled(GridDivCentered)`
	grid-template-columns: auto 1fr auto;
	gap: 5px;
`

export default DepositInfo
